<template>
  <v-app
    v-if="$store.getters.initedApp"
  >
    <v-main>
      <router-view  />
    </v-main>
  </v-app>
</template>

<script>

import { auth } from '@/fb'

export default {
  name: 'App',
  data: () => ({
  }),
  async created() {
    auth.onAuthStateChanged(user => {
      this.$store.commit('setInitedApp', true)
      this.$store.commit('setUser', user || null)
    })
  }
};
</script>
<style lang="scss">
.custom-scroll {
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -ms-scrollbar-3dlight-color: #fff;
  -webkit-scrollbar-3dlight-color: #fff;
  -moz-scrollbar-3dlight-color: #fff;
  -ms-scrollbar-3dlight-color: #fff;
  scrollbar-3dlight-color: #fff;
  -webkit-scrollbar-shadow-color: #fff;
  -moz-scrollbar-shadow-color: #fff;
  -ms-scrollbar-shadow-color: #fff;
  scrollbar-shadow-color: #fff;
  -webkit-scrollbar-face-color: rgba(22,24,35,0.34);
  -moz-scrollbar-face-color: rgba(22,24,35,0.34);
  -ms-scrollbar-face-color: rgba(22,24,35,0.34);
  scrollbar-face-color: rgba(22,24,35,0.34);
  -webkit-scrollbar-darkshadow-color: #fff;
  -moz-scrollbar-darkshadow-color: #fff;
  -ms-scrollbar-darkshadow-color: #fff;
  scrollbar-darkshadow-color: #fff;
}

.custom-scroll {
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: rgba(22,24,35,0.15);
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(22,24,35,0.3);
  }
  
    &::-webkit-scrollbar-thumb:active {
    background-color: rgba(22,24,35,0.5);
  }
}
</style>